import axios from 'axios';
import { logger } from '@fiverr-private/obs';

export const logError = (error: unknown, message?: string, enrichment?: Record<string, unknown>) => {
    if (axios.isAxiosError(error)) {
        logger.error({
            message: message ?? error.message,
            error,
            request: {
                headers: error.config.headers,
                method: error.config.method,
                url: error.config.url,
            },
            response: error.response?.data,
        });
    } else if (error instanceof Error) {
        logger.error({
            message: message ?? error.message,
            error,
            enrichment,
        });
    } else if (message) {
        logger.error({ message, enrichment });
    }
};
